jQuery(document).ready(function($) {

    function updateOphaaltijden(startDateStr) {
        const tijdopen = ["10:00", "07:30", "08:00", "08:00", "08:00", "08:00", "08:00"];
        const tijddicht = ["15:00", "18:00", "18:00", "18:00", "18:00", "18:00", "17:00"];

        const translations = {
            nl: {
                selecteer: "Selecteer",
                days: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"]
            },
            en: {
                selecteer: "Select",
                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            }
        };

        const lang = window.currentLang || 'nl';
        const t = translations[lang] || translations.nl;

        const [dag, maand, jaar] = startDateStr.split('-').map(Number);
        const datum = new Date(jaar, maand - 1, dag);
        const dagnummer = datum.getDay(); // 0 = zondag

        const dagNaam = t.days[dagnummer];
        const van = tijdopen[dagnummer];
        const tot = tijddicht[dagnummer];

        const select = document.querySelector('.ophaaltijd select');
        select.innerHTML = `<option value="">${t.selecteer}</option>`;

        const [startHour, startMin] = van.split(':').map(Number);
        const [endHour, endMin] = tot.split(':').map(Number);

        const startTime = new Date();
        startTime.setHours(startHour, startMin, 0, 0);

        const endTime = new Date();
        endTime.setHours(endHour, endMin, 0, 0);

        while (startTime <= endTime) {
            const h = String(startTime.getHours()).padStart(2, '0');
            const m = String(startTime.getMinutes()).padStart(2, '0');
            const timeStr = `${h}:${m}`;

            const option = document.createElement('option');
            option.value = timeStr;
            option.textContent = timeStr;
            select.appendChild(option);

            startTime.setMinutes(startTime.getMinutes() + 10);
        }
    }

    function updateInleverdata(startDateStr) {
        const translations = {
            nl: {
                selecteer: "Selecteer",
                days: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"]
            },
            en: {
                selecteer: "Select",
                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            }
        };

        const lang = window.currentLang || 'nl';
        const t = translations[lang] || translations.nl;

        const select = document.querySelector('.inleverdatum select');
        select.innerHTML = `<option value="">${t.selecteer}</option>`;

        const [dag, maand, jaar] = startDateStr.split('-').map(Number);
        const startDate = new Date(jaar, maand - 1, dag);

        for (let i = 0; i <= 365; i++) {
            const date = new Date(startDate);
            date.setDate(startDate.getDate() + i);

            const dayOfWeek = date.getDay(); // 0 = zondag

            if (dayOfWeek !== 0) {
                const d = String(date.getDate()).padStart(2, '0');
                const m = String(date.getMonth() + 1).padStart(2, '0');
                const y = date.getFullYear();
                const value = `${d}-${m}-${y}`;
                const label = `${t.days[dayOfWeek]} ${value}`;

                const option = document.createElement('option');
                option.value = value;
                option.textContent = label;
                select.appendChild(option);
            }
        }
    }

    function updateInlevertijden(startDateStr) {
        const tijdopen = ["10:00", "07:30", "08:00", "08:00", "08:00", "08:00", "08:00"];
        const tijddicht = ["15:00", "18:00", "18:00", "18:00", "18:00", "18:00", "17:00"];

        const translations = {
            nl: { selecteer: "Selecteer" },
            en: { selecteer: "Select" }
        };

        const lang = window.currentLang || 'nl';
        const t = translations[lang] || translations.nl;

        const select = document.querySelector('.inlevertijd select');
        select.innerHTML = `<option value="">${t.selecteer}</option>`;

        const [dag, maand, jaar] = startDateStr.split('-').map(Number);
        const datum = new Date(jaar, maand - 1, dag);
        const dagnummer = datum.getDay(); // 0 = zondag

        const van = tijdopen[dagnummer];
        const tot = tijddicht[dagnummer];

        const [startHour, startMin] = van.split(':').map(Number);
        const [endHour, endMin] = tot.split(':').map(Number);

        const startTime = new Date();
        startTime.setHours(startHour, startMin, 0, 0);

        const endTime = new Date();
        endTime.setHours(endHour, endMin, 0, 0);

        while (startTime <= endTime) {
            const h = String(startTime.getHours()).padStart(2, '0');
            const m = String(startTime.getMinutes()).padStart(2, '0');
            const timeStr = `${h}:${m}`;

            const option = document.createElement('option');
            option.value = timeStr;
            option.textContent = timeStr;
            select.appendChild(option);

            startTime.setMinutes(startTime.getMinutes() + 10);
        }
    }




    // Event bindings
    $('.ophaaldatum select').change(function() {
        const startDate = $(this).val();
        if (startDate) {
            updateOphaaltijden(startDate);
            calcDays();
        }
    });

    $('.ophaaltijd select').change(function() {
        const startDate = $(".ophaaldatum select").val();
        if (startDate) {
            updateInleverdata(startDate);
        }
    });

    $('.inleverdatum select').change(function() {
        const startDate = $(".inleverdatum select").val();
        if (startDate) {
            updateInlevertijden(startDate);
        }
    });

    $('.inlevertijd select').change(calcDays);

    // Redirect select
    $('.directreserveren select').on('change', function () {
        const url = $(this).val();
        if (url) window.location = url;
    });

    function loadOptions(selector, endpoint, startDate) {
        $(selector).load(`${endpoint}?startDate=${startDate}`);
    }

    function parseDate(str) {
        const [day, month, year] = str.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    function daydiff(first, second) {
        return (second - first) / (1000 * 60 * 60 * 24);
    }

    function calcDays() {
        const ophaaldatum = parseDate($(".ophaaldatum select").val());
        const inleverdatum = parseDate($(".inleverdatum select").val());

        const [ophaaluur, ophaalmin] = $(".ophaaltijd select").val().split(':').map(Number);
        const [inleveruur, inlevermin] = $(".inlevertijd select").val().split(':').map(Number);

        if (isNaN(ophaaluur) || isNaN(inleveruur)) return;

        const pickup = new Date(ophaaldatum);
        pickup.setHours(ophaaluur, ophaalmin, 0, 0);

        const dropoff = new Date(inleverdatum);
        dropoff.setHours(inleveruur, inlevermin, 0, 0);

        let days = daydiff(ophaaldatum, inleverdatum);

        if (ophaaldatum.getDay() === 6 && ophaaluur > 15) {
            days -= 1;
        } else if (ophaaldatum.getDay() !== 6 && ophaaluur > 16) {
            days -= 1;
        }

        const earlyReturn = (inleverdatum.getDay() === 0 && inleveruur < 11) ||
                            (inleverdatum.getDay() !== 0 && inleveruur < 10);

        if (!earlyReturn) {
            days += 1;
        }

        const quantity = days > 0 ? days : 1;
        const qtyField = document.getElementById('input_9_105') || document.getElementById('input_12_105') || document.getElementById('input_12_183') || document.getElementById('input_13_105') || document.getElementById('input_14_105');
        if (qtyField) {
            qtyField.value = quantity;
            $(qtyField).trigger('change');
        }

        // === KORTING BEREKENING ===

        let discount = 0; // standaard geen korting

        const pickupDay = pickup.getDay();
        const dropoffDay = dropoff.getDay();
        const totalHours = (dropoff - pickup) / (1000 * 60 * 60);

        // helper: bepaal of een zondag de 1e/2e/3e van de maand is
        function isFirstThreeSundays(sundayDate) {
            if (sundayDate.getDay() !== 0) return false; // moet zondag zijn
            let count = 0;
            const d = new Date(sundayDate.getFullYear(), sundayDate.getMonth(), 1);
            while (d <= sundayDate) {
                if (d.getDay() === 0) count++;
                d.setDate(d.getDate() + 1);
            }
            return count <= 3;
        }

        // ===== bestaande kortingen (laten staan als dat gewenst is) =====
        // Werkdagen ≤ 4 uur
        if (pickupDay >= 1 && pickupDay <= 5 && totalHours <= 4) {
            discount = 50;
        }
        // Na 16u ophalen, voor 9u volgende dag inleveren
        else if (
            pickupDay >= 1 && pickupDay <= 5 &&
            ophaaluur >= 16 &&
            dropoff.getDate() === pickup.getDate() + 1 &&
            inleveruur < 9
        ) {
            discount = 50;
        }
        // ===== nieuwe zondagkorting (enige weekendregel) =====
        else {
            // Alleen als: zaterdag na 15:30 ophalen
            const pickupIsSatAfter1530 = (pickupDay === 6) && (
                ophaaluur > 15 || (ophaaluur === 15 && ophaalmin >= 30)
            );

            // En: eerstvolgende maandag vóór 10:00 terug
            const dropIsNextMondayBefore10 =
                (dropoffDay === 1) &&
                // precies de maandag direct na de zaterdag
                (new Date(pickup.getFullYear(), pickup.getMonth(), pickup.getDate() + 2).toDateString() === dropoff.toDateString()) &&
                (inleveruur < 10);

            if (pickupIsSatAfter1530 && dropIsNextMondayBefore10) {
                // Bepaal de zondag ertussen (altijd 1 dag na zaterdag)
                const sunday = new Date(pickup);
                sunday.setDate(pickup.getDate() + 1);

                if (isFirstThreeSundays(sunday)) {
                    discount = 15; // zondagkorting alleen voor de 1e/2e/3e zondag van de maand
                }
            }
        }

        if ($('.product-tag[data-tag="has_discounts"]').length > 0) {
            const discountField = document.getElementById('input_9_118') || document.getElementById('input_12_118') || document.getElementById('input_13_118') || document.getElementById('input_14_118');
            if (discountField) {
                discountField.value = discount;
                $(discountField).trigger('change');
            }
        }

        if (document.getElementById('input_9_118')) {
            gformCalculateTotalPrice(9);
        } else if (document.getElementById('input_12_118')) {
            gformCalculateTotalPrice(12);
        } else if (document.getElementById('input_13_118')) {
            gformCalculateTotalPrice(13);
        } else if (document.getElementById('input_14_118')) {
            gformCalculateTotalPrice(14);
        } 

    }


});
